import { invokeApi } from "../../utils/tdlib/inVokeApi";

export const add_update_user_form = async (data) => {
  const requestObj = {
    path: `api/user_forms/update_user_form`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const add_update_addon_form = async (data) => {
  const requestObj = {
    path: `api/user_forms/submit_addon_form`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_addon_info_detail = async (data) => {
  const requestObj = {
    path: `api/user_forms/update_addon_basic_info`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const list_addon_api = async () => {
  const requestObj = {
    path: `api/user_forms/list_addon_forms`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const one_time_payment_with_stripe_api = async (data) => {
  const requestObj = {
    path: `api/payment/one_time_payment_with_stripe`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const get_client_fees_api = async () => {
  const requestObj = {
    path: `api/default_setting/get_client_fees`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const detail_user_form = async () => {
  const requestObj = {
    path: `api/user_forms/detail_user_form`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const detail_addon_form = async (id) => {
  const requestObj = {
    path: `api/user_forms/detail_addon_form/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _edit_profile_api = async (data) => {
  const requestObj = {
    path: `api/customer/edit_customer`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _applicant_audit_logs = async (data) => {
  const requestObj = {
    path: `api/applicant_audit_logs`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const submit_travel_document = async (data) => {
  const requestObj = {
    path: `api/app_api/add_booking_info/${data.id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

